import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bf6dae8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Entering the Room", -1))
const _hoisted_2 = { class: "room-card" }
const _hoisted_3 = { class: "location" }
const _hoisted_4 = { class: "members" }
const _hoisted_5 = { class: "footer-loader" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_loader = _resolveComponent("loader")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createVNode(_component_fa_icon, {
              icon: "map-marker-alt",
              size: "lg"
            }),
            _createElementVNode("span", null, _toDisplayString(this.roomName), 1)
          ]),
          _createVNode(_component_fa_icon, {
            icon: "users",
            size: "lg"
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, "Players logged in: " + _toDisplayString(this.roomPlayersCount), 1)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.progress < 100)
          ? (_openBlock(), _createBlock(_component_loader, {
              key: 0,
              progress: _ctx.progress,
              class: "loading"
            }, null, 8, ["progress"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}